module.exports = __webpack_public_path__ + "media/images/home/settings-9204ad3194dcf835ede51c5e88682288.svg";